module.exports = __webpack_public_path__ + "img/wallet_02_cross_3.c30dabfc.png";